import { render, staticRenderFns } from "./WhatsappCampaignEditor.vue?vue&type=template&id=0e9de8a5"
import script from "./WhatsappCampaignEditor.vue?vue&type=script&lang=js"
export * from "./WhatsappCampaignEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports